import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from 'react-bootstrap';
import BookFiles from './book_files.js';

import './book.scss';

const BookInformation = ({ contentId, title, description, showContentModal, setModalStates }) => {
  const onHide = () => setModalStates(prevState => ({ ...prevState, showContentModal: false }));

  return (
    <Modal
      fullscreen="md-down"
      dialogClassName="modal-900px"
      show={showContentModal}
      onHide={onHide}
      centered
    >
      {/* Header customizado */}
      <Box sx={{
        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
        padding: '20px 28px 16px',
        borderBottom: '1px solid #f0f0f0',
      }}>
        <Typography sx={{
          fontWeight: 700, fontSize: '16px', lineHeight: '24px',
          color: '#1c1b1f', textTransform: 'uppercase', letterSpacing: '0.04em',
          flex: 1, pr: '12px',
        }}>
          {title}
        </Typography>
        <IconButton onClick={onHide} size="small" sx={{ color: '#72787e', mt: '-4px' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Modal.Body style={{ padding: '0' }}>
        {description && (
          <Box sx={{ padding: '20px 28px', backgroundColor: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
            <Typography sx={{ fontSize: '14px', color: '#72787e', lineHeight: '22px' }}>
              {description}
            </Typography>
          </Box>
        )}
        <Box sx={{ padding: '8px 28px 24px' }}>
          <BookFiles contentId={contentId} />
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default BookInformation;
